import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { BillingState } from './billing.state';
import { getters } from './billing.getters';
import { mutations } from './billing.mutations';
import { actions } from './billing.actions';

VueXHelper.setStoreModule(Module.BILLING, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new BillingState(),
  getters,
  mutations,
  actions,
};
